import advice from '@/api/modules/advice'

const actions = {
  sendAppointmentEmail(context, formData) {
    return advice.sendAppointmentEmail(formData)
  }
}

export default () => ({
  namespaced: true,
  actions
})
